import styled from "styled-components";

export const Main = styled.div``;

//fundo do modal
export const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgb(0,0,0, 0.2);
    z-index: 1000;
    
    display: flex;
    align-items: center;
    justify-content: center;


    pointer-events: none; // This allows clicks to pass through to elements below
  
    & > * {
        pointer-events: auto; // But content inside the container will still receive clicks
    }
`;

//Modal
export const Content = styled.div`
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    padding: 20px;
    border-radius: 4px;
    
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 10px;
    
    height: 90%;
    width: 90%;
    max-height: 95%;

    @media (max-width: 900px) {
        width: 95%;
    }
`;

export const ContentButtonPopUp = styled.div``;

export const Title = styled.p`
    background-color: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.primary};
    box-shadow: 1px 1px 4px 0px ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 100%;
    width: 30px;
    height: 30px;
    padding: 4px 4px;

    position: absolute;
    top: -10px;
    left: -10px;
    font-size: 18px;

    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ButtonPopUp = styled.button`
    background-color: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.primary};
    box-shadow: 1px 1px 4px 0px ${(props) => props.theme.colors.gray.gray_500};
    border-radius: 30px;

    display: flex;
    align-items: center;
    justify-content: center;

    position: fixed;
    bottom: 104px;
    right: 20px;

    width: 56px;
    height: 56px;

    &:hover{
        background-color: ${(props) => props.theme.colors.gray.gray_100};
    }
`;

export const Body = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 10px;

    height: 85%;

    @media (max-width: 780px) {
        flex-direction: column;

        overflow-y: scroll;
        max-height: 100%;

        &::-webkit-scrollbar { 
            width: 5px;
            background-color: ${(props) => props.theme.colors.gray.gray_50};
            display: none;
        }
        &::-webkit-scrollbar-thumb{
            background-color: ${(props) => props.theme.colors.gray.gray_100};
            border-radius: 20px;
            display: none;
        }
    }
`;

export const Button = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    color: ${(props) => props.theme.colors.gray.gray_600};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    border-radius: 4px;
    
    &:hover {
        background-color: ${(props) => props.theme.colors.gray.gray_100};
        color: ${(props) => props.theme.colors.gray.gray_800};
    }

    &.submit-button{
        padding: 8px 12px;
        border: none;
        background-color: ${(props) => props.theme.colors.primary};
        color: ${(props) => props.theme.colors.white};
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease;
        word-wrap: nowrap;
        width: 100%;
        
        &:hover {
            background-color: ${(props) => props.theme.colors.red.red_800};
        }
    }

    &.close-button{
        width: 100%;
        height: 100%;
        background: none;
        border: 1px solid ${(props) => props.theme.colors.gray.gray_200};
        cursor: pointer;
        padding: 8px 12px;
        color: ${(props) => props.theme.colors.gray.gray_600};
        
        &:hover {
            background-color: ${(props) => props.theme.colors.gray.gray_100};
            color: ${(props) => props.theme.colors.gray.gray_800};
        }
    }
`;

export const ContentButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;

    svg{
        cursor: pointer;
    }

    @media (max-width: 900px) {
        font-size: 12px;
    }
`;

export const ContentBloc = styled.div`
    &.sub-content{
        padding: 2px 4px;
        border-left: 1px dashed ${(props) => props.theme.colors.gray.gray_200};
        border-radius: 4px;
    }
`;

export const ContentProduct = styled.div`
    border-bottom: 1px dashed ${(props) => props.theme.colors.gray.gray_200};
`;

export const ContentInfor = styled.div`
    padding: 8px 10px;
`;

export const Forms = styled.div`
    width: 70%;

    @media (min-width: 781px){
        overflow-y: scroll;
        max-height: 100%;

        &::-webkit-scrollbar { 
            width: 5px;
            background-color: ${(props) => props.theme.colors.gray.gray_50};
            display: none;
        }
        &::-webkit-scrollbar-thumb{
            background-color: ${(props) => props.theme.colors.gray.gray_100};
            border-radius: 20px;
            display: none;
        }
    }

    @media (max-width: 780px) {
        width: 100%;
        overflow: none;
    }
`;

export const FormActions = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 4px;

    background-color: ${(props) => props.theme.colors.white};
    padding: 8px 10px;
    width: 30%;
    font-size: 14px;
    border-radius: 4px;
    box-shadow: 0px -4px 4px 0px ${(props) => props.theme.colors.gray.gray_100};

    @media (max-width: 780px) {
        width: 100%;
        overflow: none;
    }

    @media (min-width: 781px){
        overflow-y: scroll;
        max-height: 100%;

        &::-webkit-scrollbar { 
            width: 5px;
            background-color: ${(props) => props.theme.colors.gray.gray_50};
            display: none;
        }
        &::-webkit-scrollbar-thumb{
            background-color: ${(props) => props.theme.colors.gray.gray_100};
            border-radius: 20px;
            display: none;
        }
    }
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 10%;
`;

export const Infor = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const InforProduct = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;

    &.infor-border{
        border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_800};
        border-top: 1px solid ${(props) => props.theme.colors.gray.gray_800};
    }
`;

export const SectionProduct = styled.div``;

export const Text = styled.p`
    &.title{
        font-size: 24px;
        color: ${(props) => props.theme.colors.gray.gray_800};
        font-weight: 500;

        @media (max-width: 780px){
            font-size: 20px;
        }
    }

    &.subtitle {
        color: ${(props) => props.theme.colors.gray.gray_500};
        font-size: 14px;
    }

    &.desc {
        color: ${(props) => props.theme.colors.gray.gray_500};
        font-size: 10px;
    }
`;